/* eslint-disable @typescript-eslint/no-explicit-any */
export function isUndefined(value) {
    return typeof value === 'undefined';
}
export function isArray(value) {
    return Array.isArray(value);
}
// checks if the device is touch based
export const isTouchDevice = (() => {
    return (!!(typeof window !== 'undefined' &&
        ('ontouchstart' in window ||
            (window.DocumentTouch &&
                typeof document !== 'undefined' &&
                document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' &&
            (navigator.maxTouchPoints || navigator.msMaxTouchPoints)));
})();
// checks if the given value is a string
export function isValidString(value) {
    return typeof value === 'string' && !isUndefined(value) && value !== null;
}
// checks if the app is in dark mode
export function isDark() {
    return (document.documentElement.style.getPropertyValue('--rc-dark-mode') === 'true');
}
